import React from 'react';

const BuildingCityIcon = ({
  width = '18',
  height = '18',
  fill = 'none',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill={fill}
    {...props}
  >
    <g opacity="0.5" clipPath="url(#clip0_4003_8270)">
      <path
        d="M3 3H10.5C10.6989 3 10.8897 3.07902 11.0303 3.21967C11.171 3.36032 11.25 3.55109 11.25 3.75V15H3C2.80109 15 2.61032 14.921 2.46967 14.7803C2.32902 14.6397 2.25 14.4489 2.25 14.25V3.75C2.25 3.55109 2.32902 3.36032 2.46967 3.21967C2.61032 3.07902 2.80109 3 3 3Z"
        stroke="#323232"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 6H15C15.1989 6 15.3897 6.07902 15.5303 6.21967C15.671 6.36032 15.75 6.55109 15.75 6.75V14.25C15.75 14.4489 15.671 14.6397 15.5303 14.7803C15.3897 14.921 15.1989 15 15 15H11.25V6Z"
        stroke="#323232"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.20898 5.51074C5.06065 5.51074 4.91564 5.55473 4.79231 5.63714C4.66897 5.71955 4.57284 5.83669 4.51608 5.97373C4.45931 6.11078 4.44446 6.26158 4.4734 6.40706C4.50233 6.55255 4.57376 6.68618 4.67865 6.79107C4.78354 6.89596 4.91718 6.96739 5.06267 6.99633C5.20815 7.02527 5.35895 7.01042 5.496 6.95365C5.63304 6.89689 5.75018 6.80076 5.83259 6.67742C5.915 6.55409 5.95898 6.40908 5.95898 6.26074C5.95898 6.06183 5.87997 5.87106 5.73932 5.73041C5.59866 5.58976 5.4079 5.51074 5.20898 5.51074Z"
        fill="#323232"
      />
      <path
        d="M8.20898 5.51074C8.06065 5.51074 7.91564 5.55473 7.7923 5.63714C7.66897 5.71955 7.57284 5.83669 7.51607 5.97373C7.45931 6.11078 7.44446 6.26158 7.4734 6.40706C7.50234 6.55255 7.57376 6.68618 7.67865 6.79107C7.78354 6.89596 7.91718 6.96739 8.06267 6.99633C8.20815 7.02527 8.35895 7.01042 8.496 6.95365C8.63304 6.89689 8.75017 6.80076 8.83258 6.67742C8.915 6.55409 8.95898 6.40908 8.95898 6.26074C8.95898 6.06183 8.87997 5.87106 8.73931 5.73041C8.59866 5.58976 8.4079 5.51074 8.20898 5.51074Z"
        fill="#323232"
      />
      <path
        d="M5.20898 8.51074C5.06065 8.51074 4.91564 8.55473 4.79231 8.63714C4.66897 8.71955 4.57284 8.83669 4.51608 8.97373C4.45931 9.11078 4.44446 9.26158 4.4734 9.40706C4.50233 9.55255 4.57376 9.68618 4.67865 9.79107C4.78354 9.89596 4.91718 9.96739 5.06267 9.99633C5.20815 10.0253 5.35895 10.0104 5.496 9.95365C5.63304 9.89689 5.75018 9.80076 5.83259 9.67742C5.915 9.55409 5.95898 9.40908 5.95898 9.26074C5.95898 9.06183 5.87997 8.87106 5.73932 8.73041C5.59866 8.58976 5.4079 8.51074 5.20898 8.51074Z"
        fill="#323232"
      />
      <path
        d="M8.20898 8.51074C8.06065 8.51074 7.91564 8.55473 7.7923 8.63714C7.66897 8.71955 7.57284 8.83669 7.51607 8.97373C7.45931 9.11078 7.44446 9.26158 7.4734 9.40706C7.50234 9.55255 7.57376 9.68618 7.67865 9.79107C7.78354 9.89596 7.91718 9.96739 8.06267 9.99633C8.20815 10.0253 8.35895 10.0104 8.496 9.95365C8.63304 9.89689 8.75017 9.80076 8.83258 9.67742C8.915 9.55409 8.95898 9.40908 8.95898 9.26074C8.95898 9.06183 8.87997 8.87106 8.73931 8.73041C8.59866 8.58976 8.4079 8.51074 8.20898 8.51074Z"
        fill="#323232"
      />
      <path
        d="M5.20898 11.5107C5.06065 11.5107 4.91564 11.5547 4.79231 11.6371C4.66897 11.7196 4.57284 11.8367 4.51608 11.9737C4.45931 12.1108 4.44446 12.2616 4.4734 12.4071C4.50233 12.5525 4.57376 12.6862 4.67865 12.7911C4.78354 12.896 4.91718 12.9674 5.06267 12.9963C5.20815 13.0253 5.35895 13.0104 5.496 12.9536C5.63304 12.8969 5.75018 12.8008 5.83259 12.6774C5.915 12.5541 5.95898 12.4091 5.95898 12.2607C5.95898 12.0618 5.87997 11.8711 5.73932 11.7304C5.59866 11.5898 5.4079 11.5107 5.20898 11.5107Z"
        fill="#323232"
      />
      <path
        d="M8.20898 11.5107C8.06065 11.5107 7.91564 11.5547 7.7923 11.6371C7.66897 11.7196 7.57284 11.8367 7.51607 11.9737C7.45931 12.1108 7.44446 12.2616 7.4734 12.4071C7.50234 12.5525 7.57376 12.6862 7.67865 12.7911C7.78354 12.896 7.91718 12.9674 8.06267 12.9963C8.20815 13.0253 8.35895 13.0104 8.496 12.9536C8.63304 12.8969 8.75017 12.8008 8.83258 12.6774C8.915 12.5541 8.95898 12.4091 8.95898 12.2607C8.95898 12.0618 8.87997 11.8711 8.73931 11.7304C8.59866 11.5898 8.4079 11.5107 8.20898 11.5107Z"
        fill="#323232"
      />
      <path
        d="M13.459 8.51074C13.3106 8.51074 13.1656 8.55473 13.0423 8.63714C12.919 8.71955 12.8228 8.83669 12.7661 8.97373C12.7093 9.11078 12.6945 9.26158 12.7234 9.40706C12.7523 9.55255 12.8238 9.68618 12.9287 9.79107C13.0335 9.89596 13.1672 9.96739 13.3127 9.99633C13.4582 10.0253 13.609 10.0104 13.746 9.95365C13.883 9.89689 14.0002 9.80076 14.0826 9.67742C14.165 9.55409 14.209 9.40908 14.209 9.26074C14.209 9.06183 14.13 8.87106 13.9893 8.73041C13.8487 8.58976 13.6579 8.51074 13.459 8.51074Z"
        fill="#323232"
      />
      <path
        d="M13.459 11.5107C13.3106 11.5107 13.1656 11.5547 13.0423 11.6371C12.919 11.7196 12.8228 11.8367 12.7661 11.9737C12.7093 12.1108 12.6945 12.2616 12.7234 12.4071C12.7523 12.5525 12.8238 12.6862 12.9287 12.7911C13.0335 12.896 13.1672 12.9674 13.3127 12.9963C13.4582 13.0253 13.609 13.0104 13.746 12.9536C13.883 12.8969 14.0002 12.8008 14.0826 12.6774C14.165 12.5541 14.209 12.4091 14.209 12.2607C14.209 12.0618 14.13 11.8711 13.9893 11.7304C13.8487 11.5898 13.6579 11.5107 13.459 11.5107Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_4003_8270">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BuildingCityIcon;
